module.exports = __webpack_public_path__ + "img/img-works_7.1836c936.png";